<app-item [entity]="visitReason" *ngIf="visitReason"
          [deleteService]="deleteService"
        [deleteButtonInMore]="true">
    <app-luna-button more-buttons iconName="pencil" (clickedEvent)="edit()"></app-luna-button>

    <app-summary [expandable]="true">
        <div title>
            <ng-container *ngIf="titleDisplay === 'title'">
                Motifs de consultation
            </ng-container>
            <ng-container *ngIf="titleDisplay === 'date'">
                <app-date-label [date]="visitReason.date"></app-date-label>
            </ng-container>
        </div>
        <ng-container expandedContent>
            <ng-container *ngIf="visitReason.labels?.length > 0">
                <div class="d-flex gap flex-wrap" *ngFor="let label of visitReason.labels">
                    <app-lov-value-summary-field *ngIf="label.lovValue" [lovValueSummary]="label.lovValue"></app-lov-value-summary-field>
                    <app-summary-field *ngIf="label.customValue" [value]="label.customValue"></app-summary-field>
                </div>
                <div class="divider"></div>
            </ng-container>
            <ng-container *ngIf="visitReason.comment">
                <div class="text" [innerHTML]="visitReason.comment"></div>
                <div class="divider"></div>
            </ng-container>
            <ng-container *ngIf="visitReason?.pains?.length > 0">
                <strong>Douleurs</strong>
                <div class="container-padding-left">
                    <div *ngFor="let pain of visitReason.pains">
                        <app-luna-consultation-pain-item [hideButtons]="true" [pain]="pain" [hideDate]="true"></app-luna-consultation-pain-item>
                    </div>
                    <div class="divider"></div>
                </div>
            </ng-container>
            <ng-container *ngIf="visitReason?.problems?.length > 0">
                <strong>Problèmes</strong>
                <div class="container-padding-left">
                    <div *ngFor="let problem of visitReason.problems">
                        <app-luna-consultation-problem-item [hideButtons]="true" [problem]="problem"></app-luna-consultation-problem-item>
                    </div>
                    <div class="divider"></div>
                </div>
            </ng-container>
        </ng-container>
    </app-summary>
</app-item>